var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemTypeServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.9961C19.2614 17.9961 21.5 15.7575 21.5 12.9961C21.5 10.2347 19.2614 7.99609 16.5 7.99609C13.7386 7.99609 11.5 10.2347 11.5 12.9961C11.5 15.7575 13.7386 17.9961 16.5 17.9961Z",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30078 22.4968C9.95931 21.1482 10.9834 20.0116 12.2563 19.2166C13.5293 18.4215 15 18 16.5008 18C18.0016 18 19.4723 18.4215 20.7452 19.2166C22.0182 20.0116 23.0423 21.1482 23.7008 22.4968",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0625 10.0723C28.0306 10.3554 29.8061 11.4073 31 12.9973",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3867 4.27164C21.6771 3.66551 22.1156 3.14232 22.6616 2.75041C23.2077 2.35849 23.8436 2.11049 24.5108 2.02929C25.178 1.9481 25.8549 2.03634 26.479 2.28586C27.1031 2.53538 27.6543 2.93814 28.0816 3.45693C28.5089 3.97573 28.7986 4.59383 28.9239 5.25416C29.0492 5.91449 29.0061 6.59576 28.7986 7.23504C28.5911 7.87432 28.2258 8.451 27.7365 8.91182C27.2473 9.37264 26.6498 9.70275 25.9992 9.87164",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99873 9.87164C6.34818 9.70275 5.75068 9.37264 5.2614 8.91182C4.77213 8.451 4.40687 7.87432 4.19935 7.23504C3.99182 6.59576 3.94873 5.91449 4.07406 5.25416C4.19938 4.59383 4.48907 3.97573 4.91638 3.45693C5.3437 2.93814 5.89485 2.53538 6.51893 2.28586C7.14302 2.03634 7.81992 1.9481 8.48711 2.02929C9.15431 2.11049 9.79029 2.35849 10.3363 2.75041C10.8823 3.14232 11.3208 3.66551 11.6112 4.27164",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.9973C3.1939 11.4073 4.96944 10.3554 6.9375 10.0723",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTypeServiceIcon);
export default __webpack_public_path__ + "static/media/item-type-service-icon.f31ace7de2170ef83bc99b079465909e.svg";
export { ForwardRef as ReactComponent };